import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { Input, Textarea } from '@salesforce/design-system-react';
import { BasicInfo } from '../images/illustrations/experiment-tips';
import { ExperimentEditStep } from '../';
import './ExperimentEditInfo.scss';

class ExperimentEditInfo extends Component {
  getI18nID(suffix) {
    return `components.experiment.experimentWizard.${suffix}`;
  }

  renderTips() {
    const { formatMessage } = this.props.intl;
    const tipTitle = formatMessage({
      id: this.getI18nID('step0.title')
    });
    const tip1 = formatMessage({
      id: this.getI18nID('step0.tip1')
    });
    const tip2 = formatMessage({
      id: this.getI18nID('step0.tip2')
    });
    return (
      <div className="tips slds-col">
        <div className="tip-image">
          <BasicInfo />
        </div>
        <p>{tipTitle}</p>
        <ul>
          <li>{tip1}</li>
          <li>{tip2}</li>
        </ul>
      </div>
    );
  }

  render() {
    const { actions, experiment } = this.props;
    const { formatMessage } = this.props.intl;
    const hasName = !!experiment.name;
    let title = formatMessage({
      id: this.getI18nID('titles.info')
    });

    return (
      <div className="experiment-container slds-grid">
        <ExperimentEditStep actions={actions} canNav={hasName} step="step0" />
        <div className="info slds-col">
          {title ? <span className="info-container-title">{title}</span> : null}

          <Input
            key="name-input"
            className="field-input"
            defaultValue={experiment.name || ''}
            required={true}
            label={formatMessage({ id: this.getI18nID('fields.name') })}
            onChange={(_evt, { value }) =>
              this.props.onFieldChange('name', value)
            }
          />
          <Textarea
            id="desc-input"
            label={formatMessage({ id: this.getI18nID('fields.description') })}
            defaultValue={experiment.description || ''}
            onChange={event =>
              this.props.onFieldChange('description', event?.target?.value)
            }
          />
        </div>
        {this.renderTips()}
      </div>
    );
  }
}

ExperimentEditInfo.propTypes = {
  actions: PropTypes.object,
  experiments: PropTypes.object,
  modals: PropTypes.object,
  experiment: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'create']),
  onFieldChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ExperimentEditInfo);
